import { ShieldCheck } from "lucide-react";
import { CHANNEL_URL } from "@/constants/campaign";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-200/70 px-4 py-12 sm:px-6">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 text-center">
        <a href={CHANNEL_URL} target="_blank" rel="noopener noreferrer" className="font-display text-base font-extrabold tracking-tight text-slate-900">
          FXTM Africa
        </a>
        <p className="flex max-w-2xl items-start gap-2 text-xs leading-relaxed text-slate-500">
          <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-red-600/70" />
          Winners are selected at random from eligible YouTube comments and announced live on the official
          @fxtm.africa channel. We will never DM you first or ask for payments, gift cards, or wallet keys.
          Trading involves risk; this promotion is not financial advice. 18+ only. Terms apply on the channel.
        </p>
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-600">
          © 2026 FXTM Africa Gold Drop — Community Giveaway
        </p>
      </div>
    </footer>
  );
}
